import React from 'react';
import { AccordionItem } from 'Components/widgets/accordion-block/AccordionItem';
type Props = {
  priceDetail: Record<string, any>;
  trackingEventName: string;
};
export const PriceDetailLines = ({ trackingEventName, priceDetail }: Props) => {
  return (
    priceDetail &&
    priceDetail.map((props, index) => {
      return (
        <AccordionItem
          key={index}
          {...props}
          trackingData={{
            ...props.trackingData,
            event: trackingEventName || props.trackingData.event,
          }}
        />
      );
    })
  );
};
